@if (notification$ | async; as notification) {
  <ng-container>
    <nexweb-deactivation-notification-form
      [notification]="notification"
      [labels]="labels"
      [headings]="headings"
      [dateTimeFormat]="dateTimeFormat"></nexweb-deactivation-notification-form>
  </ng-container>
}
